<script lang="ts">
  import { writable } from 'svelte/store'
  import { createEventDispatcher } from 'svelte'
  import type { Country, Inventory, Membership } from '../../api/types'
  import { Buttons, Select } from '../../elements'
  import { normalizeInventoryOptions, handleCurrencySign } from '../../helpers'
  import ViewInventoryBenefits from './ViewInventoryBenefits.svelte'

  export let inventories: Inventory[]
  export let membership: Membership
  export let userCountry: Country

  const currency = handleCurrencySign(userCountry)

  const oneYearAfterExpiration = (() => {
    const expiredAt = new Date(membership.expireAt)
    expiredAt.setFullYear(expiredAt.getFullYear() + 1)
    return expiredAt;
  })()

  const dispatch = createEventDispatcher()

  let selected = writable<Inventory>(inventories.filter(({ id }) => membership.subscription.context.inventoryId === id)[0] || {} as Inventory)

  $: selectValueChanged = $selected.id !== membership.subscription.context.inventoryId

  function change(product) {
    dispatch('change', product)
  }
</script>

<style>
  .select {
    margin-bottom: 24px;
  }
  .membership.label {
    color: #8e949a;
  }

  .membership.name {
    font-weight: 600;
  }

  .membership.current {
    margin-bottom: 16px;
  }

  .membership.current * {
    line-height: 22px;
  }

  .benefits.label {
    margin-top: 24px;
    margin-bottom: 8px;
  }

  .benefits.label.current {
    margin-top: 32px;
    font-weight: bold;
  }

  hr {
    height: 1px;
    background-color: #dee0e2;
    border: none;
    margin: 0;
  }

  .benefits.content {
    font-size: 12px;
    line-height: 16px;
    color: #484c51;
  }

  .new-price {
    line-height: 16px;
    font-weight: bold;
    margin-top: 32px;
  }
</style>


<div class="current membership">
  <span class="membership label">Current Renewal Plan:</span>
  <span class="membership name" data-test="current-renewal">{$selected.name}</span>
</div>

<div class="select">
  <Select
    dataCy="change-renewal"
    value={$selected}
    on:input={({ detail }) => $selected = detail}
    placeholder="Please choose a renewal plan"
    options={normalizeInventoryOptions(inventories, currency)}
  />
</div>

{#if !selectValueChanged}
  <p class="benefits label current" data-test="benefits-label">Current Renewal Plan Benefits:</p>
  <ViewInventoryBenefits {inventories} {userCountry} selectedInventory={$selected} />
{:else}
  <hr />
  <p class="benefits label" data-test="benefits-label">New Benefits: {$selected.name}</p>
  <ViewInventoryBenefits {inventories} {userCountry} selectedInventory={$selected} />

  <p style="margin-top: 32px;" data-test="effective-label">Effective:</p>
  <p class="benefits content" data-test="effective-detail">
    The renewal plan will be effective for one year after the current membership is expired, starting {new Date(membership.expireAt).toLocaleDateString()} through {oneYearAfterExpiration.toLocaleDateString()}
  </p>
  <p class="new-price" data-test="new-price">New annual price: {currency}{($selected.priceCents.amount / 100).toFixed(2)}</p>
{/if}

<Buttons
  confirm="Continue"
  on:confirm={() => change($selected)}
  confirmDisabled={!selectValueChanged}
  on:cancel
/>



